import React, {useState} from 'react';
import clsx from "clsx";
import {useFormik} from "formik";
import {login} from "../../services/authSvc";
import {useAuth} from "../../modules/auth";
import {setHeaderToken} from "../../services/api";
import {getUserByToken} from "../../modules/auth/core/_requests";

export const LoginPage = () => {
  const {saveAuth, setCurrentUser} = useAuth();
  const [errorMessage, setErrorMessage] = useState('');

  const formik = useFormik({
    initialValues: {
      phone: '998943067661',
      password: '12345678Aa'
    },
    onSubmit: async (values) => {
      try {
        const res = await login(values);
        if (res?.status === 200) {
          saveAuth(res?.data?.data);
          setHeaderToken(res?.data?.data?.access);
          const {data: user} = await getUserByToken();
          setCurrentUser(user.data);
        } else if (res?.status === 401) {
          setErrorMessage('Foydalanuvchi mavjud emas');
        }
      } catch (e: any) {
        if (e?.response?.status === 401) {
          setErrorMessage('Foydalanuvchi mavjud emas');
        } else {
          setErrorMessage('Login yoki parolda xatolik mavjud');
        }
      }
    }
  });

  return (
      <div>
        <div className='text-center mb-11'>
          <h1 className='text-dark fw-bolder mb-3'>Kirish</h1>
          <div className='text-gray-500 fw-semibold fs-6'>Platformaga kirish</div>
        </div>

        <form action="" onSubmit={formik.handleSubmit}>
          <div className='fv-row mb-8'>
            <label className='form-label fs-6 fw-bolder text-dark'>Login</label>
            <input
                placeholder='Loginni kiriting'
                {...formik.getFieldProps('phone')}
                className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.phone && formik.errors.phone},
                    {'is-valid': formik.touched.phone && !formik.errors.phone}
                )}
                type='phone'
                name='phone'
                autoComplete='off'
            />
            {formik.touched.phone && formik.errors.phone && (
                <div className='fv-plugins-message-container'>
                  <span role='alert'>{formik.errors.phone}</span>
                </div>
            )}
          </div>

          <div className='fv-row mb-3'>
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Parol</label>
            <input
                type='password'
                autoComplete='off'
                placeholder='Parol'
                {...formik.getFieldProps('password')}
                className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.password && formik.errors.password},
                    {'is-valid': formik.touched.password && !formik.errors.password}
                )}
            />
            {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
            )}
          </div>

          {errorMessage && (
              <div className='alert alert-danger' role='alert'>
                {errorMessage}
              </div>
          )}
          <div className='d-grid mb-10'>
            <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-primary'
                disabled={formik.isSubmitting || !formik.isValid}
            >
              {formik.isSubmitting ? "Kirilmoqda..." : "Kirish"}
            </button>
          </div>
        </form>
      </div>
  );
};